import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TCreateNewRegionReduxParams } from '~types/feat/branch';

export default function* watchCreateNewRegion(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchCreateNewRegionAttempt', handleCreateNewRegion, api);
}

function* handleCreateNewRegion(api: BranchGateway, action: PayloadAction<TCreateNewRegionReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { regionName } = action.payload;

    if (!regionName) {
        yield put(combinedActions.branchCreateNewRegionFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.createNewRegion], {
        authToken,
        regionName,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchCreateNewRegionFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.branchCreateNewRegionSuccess());
        yield put(combinedActions.branchSetCreateNewRegionModalIsOpen(false));
        yield put(combinedActions.branchSetRegionListingIndex({ index: 0 }));
        yield put(combinedActions.branchGetRegionListingAttempt()); // for rendering the list in branch management
        yield put(combinedActions.branchGetAllRegionsAttempt()); // for filters (separate API to get all)

        toast.success(SuccessMessages.BranchCreateNewRegionSuccess);
    }
}
